// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2KfIB","col":"styles_col__RmF3q","fulfillmentStatus":"styles_fulfillmentStatus__n_ggA","emailCol":"styles_emailCol__1blI6"};